export const sanitizeZipCode = (zipCode?: string | null): string =>
    (zipCode ?? '').replace(/\D/g, '').slice(0, 9);

export const getZipCodeFormat = (zipCode?: string | null): string => {
    const cleanedValue = sanitizeZipCode(zipCode);
    if (cleanedValue.length <= 5) {
        return cleanedValue;
    }
    return `${cleanedValue.slice(0, 5)}-${cleanedValue.slice(5)}`;
}
